// extracted by mini-css-extract-plugin
module.exports = {"button":"ErrorDemo_button__1GXc_"};